"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchIconButton = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var React = __importStar(require("react"));
var SvgIcon_1 = __importDefault(require("@atg/icf-react-components/components/SvgIcon"));
var react_jss_1 = require("react-jss");
var useSearchIconButtonStyles = (0, react_jss_1.createUseStyles)({
    thumbnailButton: {
        marginInlineStart: 16,
        padding: 0,
        border: "none",
        background: "none",
        cursor: "pointer",
        outline: "none",
    },
});
var SearchIconButton = function (props) {
    var fill = props.fill, iconName = props.iconName, onClick = props.onClick, iconSize = props.iconSize;
    var classes = useSearchIconButtonStyles();
    return (React.createElement("button", { className: classes.thumbnailButton, onClick: onClick },
        React.createElement(SvgIcon_1.default, { size: iconSize, name: iconName, fill: fill })));
};
exports.SearchIconButton = SearchIconButton;
exports.SearchIconButton.displayName = "SearchIconButton";
//# sourceMappingURL=SearchIconButton.js.map